import naturalSort from "javascript-natural-sort";

function numeric(a, b, dsc=false) {
    let order = a - b;

    return reversible(order, dsc);
}

function natural(a, b, dsc=false) {
    let order = naturalSort(a, b);

    return reversible(order, dsc);
}

function modelNumeric(prop, a, b, dsc=false) {
    return model(numeric, prop, a, b, dsc);
}

function modelNatural(prop, a, b, dsc=false) {
    return model(natural, prop, a, b, dsc);
}

function model(fn, prop, a, b, dsc=false) {
    return fn(a.get(prop), b.get(prop), dsc);
}

function reversible(order, rev=false) {
    return rev ? reverse(order) : order;
}

function reverse(order) {
    return -1 * order;
}

export {
    numeric,
    natural,
    modelNumeric,
    modelNatural,
    model
};
